import { MODULES } from "../../constants/constants";

/**
 * Sidebar menu.
 * - iconKey: maps to SideMenuIcons.SIDE_ICONS
 * - section: group label (shown once when the section changes in the filtered list)
 */
export const MENUITEMS = [
  {
    Items: [
      {
        path: `${process.env.PUBLIC_URL}/dashboard`,
        iconKey: "dashboard",
        section: "Overview",
        type: "link",
        active: false,
        selected: false,
        title: "Vendor Dashboard",
        module: MODULES.DASHBOARD,
      },

      {
        path: `${process.env.PUBLIC_URL}/masters`,
        iconKey: "masters",
        section: "Directory",
        type: "link",
        active: false,
        selected: false,
        title: "Masters",
        module: MODULES.MASTERS,
      },
      {
        path: `${process.env.PUBLIC_URL}/vendors`,
        iconKey: "vendors",
        section: "Directory",
        type: "link",
        active: false,
        selected: false,
        title: "Vendors",
        module: MODULES.VENDORS,
      },

      {
        path: `${process.env.PUBLIC_URL}/purchase-requisitions`,
        iconKey: "procurement",
        section: "Operations",
        type: "sub",
        active: false,
        selected: false,
        title: "Procurement",
        module: MODULES.PR,
        children: [
          {
            path: `${process.env.PUBLIC_URL}/purchase-requisitions`,
            type: "link",
            active: false,
            selected: false,
            title: "Purchase Requisitions",
            module: MODULES.PR,
          },
          {
            path: `${process.env.PUBLIC_URL}/request-for-quotations`,
            type: "link",
            active: false,
            selected: false,
            title: "Request for Quotations",
            module: MODULES.RFQ,
          },
          {
            path: `${process.env.PUBLIC_URL}/vendor-quotations`,
            type: "link",
            active: false,
            selected: false,
            title: "Vendor Quotations",
            module: MODULES.QUOTATIONS,
          },
          {
            path: `${process.env.PUBLIC_URL}/purchase-order`,
            type: "link",
            active: false,
            selected: false,
            title: "Purchase Orders",
            module: MODULES.PURCHASE_ORDERS,
          },
        ],
      },
      {
        path: `${process.env.PUBLIC_URL}/shipments`,
        iconKey: "shipments",
        section: "Operations",
        type: "link",
        active: false,
        selected: false,
        title: "Shipments",
        module: MODULES.SHIPMENTS,
      },
      {
        path: `${process.env.PUBLIC_URL}/service-delivery`,
        iconKey: "package",
        section: "Operations",
        type: "link",
        active: false,
        selected: false,
        title: "Service Delivery",
        module: MODULES.SERVICE_DELIVERY,
      },

      {
        path: `${process.env.PUBLIC_URL}/invoice-parking`,
        iconKey: "file-plus",
        section: "Finance",
        type: "link",
        active: false,
        selected: false,
        title: "Invoice Parking",
        module: MODULES.INVOICE_PARKING,
      },
      {
        path: `${process.env.PUBLIC_URL}/invoices`,
        iconKey: "invoice",
        section: "Finance",
        type: "link",
        active: false,
        selected: false,
        title: "Invoices",
        module: MODULES.INVOICES,
      },
      {
        path: `${process.env.PUBLIC_URL}/po-payment-summary`,
        iconKey: "payment",
        section: "Finance",
        type: "link",
        active: false,
        selected: false,
        title: "PO Payment Summary",
        module: MODULES.PO_PAYMENT_SUMMARY,
      },

      {
        path: `${process.env.PUBLIC_URL}/modules`,
        iconKey: "settings",
        section: "Administration",
        type: "sub",
        active: false,
        selected: false,
        title: "System Admin",
        module: MODULES.MODULES,
        children: [
          {
            path: `${process.env.PUBLIC_URL}/modules`,
            type: "link",
            active: false,
            selected: false,
            title: "Modules",
            module: MODULES.MODULES,
          },
          {
            path: `${process.env.PUBLIC_URL}/roles`,
            type: "link",
            active: false,
            selected: false,
            title: "Roles",
            module: MODULES.ROLES,
          },
          {
            path: `${process.env.PUBLIC_URL}/users`,
            type: "link",
            active: false,
            selected: false,
            title: "Users",
            module: MODULES.USERS,
          },
          {
            path: `${process.env.PUBLIC_URL}/approval-threshold`,
            type: "link",
            active: false,
            selected: false,
            title: "Approval Threshold",
            module: MODULES.APPROVAL_THRESHOLD,
          },
        ],
      },
      {
        path: `${process.env.PUBLIC_URL}/mdmreports`,
        iconKey: "monitoring",
        section: "Administration",
        type: "link",
        active: false,
        selected: false,
        title: "MDM Reports",
        module: MODULES.MDMREPORTS,
      },
    ],
  },
];

/**
 * Flatten sidebar links (leaf nodes only) for landing-page selection.
 * Nested modules (RFQ, PO, etc.) use their current list routes — not parent stubs like /pr.
 */
export const collectMenuLandingLinks = (items = MENUITEMS[0]?.Items || []) => {
  const links = [];
  const walk = (list) => {
    (list || []).forEach((item) => {
      if (item?.children?.length) {
        walk(item.children);
        return;
      }
      if (item?.module && item?.path) {
        links.push({
          module: item.module,
          title: item.title,
          path: item.path,
        });
      }
    });
  };
  walk(items);
  return links;
};

/** Unique modules → path/title for Roles landing dropdown (first leaf wins). */
export const getLandingModuleOptions = () => {
  const byModule = new Map();
  collectMenuLandingLinks().forEach((link) => {
    if (!byModule.has(link.module)) {
      byModule.set(link.module, link);
    }
  });
  return Array.from(byModule.values());
};

/** Resolve post-login path from a role's landingModule code. */
export const resolveLandingPathByModule = (moduleName) => {
  if (!moduleName) return null;
  const key = String(moduleName).trim();
  if (!key) return null;
  return (
    getLandingModuleOptions().find((opt) => opt.module === key)?.path || null
  );
};
